<template>
  <aside class="project-info info-right-cont info-right-cont_small"
         v-if="project">
    <header class="info-header">
      <div class="info-header-left">
        <div class="header-wrap">
          <p class="label">{{$t('projects.projectsList.nameLb')}}</p>
          <h1 class="bit-title">
            <trim-item :string="project.name" :width="1"></trim-item>
          </h1>
        </div>
        <div class="header-wrap">
          <p class="label">
            {{$t('labels.created')}}
          </p>
          <h3 class="description">
            {{timestampToDataWithTime(project.created_at)}}
          </h3>
        </div>
      </div>
      <div class="info-header-right">
        <avatar-cont :img-url="avatar"
                     @upload="saveAvatar($event)"
                     :editable="false"
                     :is-project="true"
                     @del="clearAvatar"></avatar-cont>
      </div>
    </header>
    <main class="info-body">
      <div class="header-wrap desc-wrap">
        <p class="label">
          {{$t('forms.descLb')}}
        </p>
        <textarea :value="project.description"
                  readonly
                  class="description project-desc">
        </textarea>
      </div>

      <div class="header-wrap owner-wrap">

        <div class="permission-header">
          <p class="label">
            {{$t('labels.owners')}}
          </p>
          <button type="button"
                  v-if="(permissionCheck > 3) && ($route.name === 'project') && false"
                  @click="addPermissionUsers"
                  class="add-permission">
            {{$t('projects.project.share')}}
            <add-icon></add-icon>
          </button>
        </div>

        <div class="owner-cont" v-if="isAdminRole && ownerRole(project.owner_role_id)">
          <div class="icon-small"
               :class="{'icon-small_border': !ownerRole(project.owner_role_id).user.contacts.avatar_url}"
               :style="{backgroundImage: `url(${ownerRole(project.owner_role_id).user.contacts.avatar_url})`}">
            <user-icon v-if="!ownerRole(project.owner_role_id).user.contacts.avatar_url"></user-icon>
          </div>
          <p class="description owner-name-cont">
            {{ownerRole(project.owner_role_id).user.first_name}}
            <span v-if="ownerRole(project.owner_role_id).user.second_name">{{ownerRole(project.owner_role_id).user.second_name}}</span>
            <star-icon></star-icon>
          </p>
        </div>

        <div class="owner-cont" v-if="!isAdminRole && !isItemProjects && ownerRole(project.owner_role_id)">
          <div class="icon-small"
               :class="{'icon-small_border': !ownerRole(project.owner_role_id).user.contacts.avatar_url}"
               :style="{backgroundImage: `url(${ownerRole(project.owner_role_id).user.contacts.avatar_url})`}">
            <user-icon v-if="!ownerRole(project.owner_role_id).user.contacts.avatar_url"></user-icon>
          </div>
          <p class="description owner-name-cont">
            {{ownerRole(project.owner_role_id).user.first_name}}
            <span v-if="ownerRole(project.owner_role_id).user.second_name">{{ownerRole(project.owner_role_id).user.second_name}}</span>
            <star-icon></star-icon>
          </p>
        </div>

        <div class="owner-cont" v-if="!isAdminRole && isItemProjects && project.owner">
          <div class="icon-small"
               :class="{'icon-small_border': !project.owner.user.contacts.avatar_url}"
               :style="{backgroundImage: `url(${project.owner.user.contacts.avatar_url})`}">
            <user-icon v-if="!project.owner.user.contacts.avatar_url"></user-icon>
          </div>
          <p class="description owner-name-cont">
            {{project.owner.user.first_name}}
            <span v-if="project.owner.user.second_name">{{project.owner.user.second_name}}</span>
            <star-icon></star-icon>
          </p>
        </div>
        <div v-if="isAdminRole"
             v-for="owner in projectOwners"
             class="owner-cont">
          <div class="icon-small"
               v-if="owner.user && owner.user.contacts && owner.user.contacts.avatar_url"
               :style="{backgroundImage: `url(${owner.user.contacts.avatar_url})`}"></div>
          <user-icon class="icon-small icon-small_border"
                     v-else></user-icon>
          <p class="description owner-name-cont">
            {{owner.user.first_name}} <span v-if="owner.user.second_name">{{owner.user.second_name}}</span>
          </p>
        </div>

      </div>
      <div class="header-wrap permission-wrap">
        <div class="permission-header">
          <p class="label">
            {{$t('menu.users')}}
          </p>
          <button type="button"
                  v-if="permissionCheck > 3"
                  @click="addPermissionRoles"
                  class="add-permission">
            {{$t('projects.project.share')}}
            <add-icon></add-icon>
          </button>
        </div>
        <ul v-if="isAdminRole" class="permissions-list">
          <li class="owner-cont permission-item"
              v-for="(role, i) in projectRoles"
              :key="i">
            <p class="description">
             {{returnRoleName(role.role_id).name}}
            </p>
          </li>
        </ul>
      </div>
    </main>
    <footer class="info-footer">
      <!--{{linkToEdit}}-->
      <router-link :to="linkToEdit" class="btn btn-transparent_blue">
        <span v-if="permissionCheck > 1">
          {{$t('projects.project.edit')}}
        </span>
        <span v-else>
          {{$t('projects.project.show')}}
        </span>
      </router-link>

      <!--      @click="checkDel"-->
      <button type="button"
              @click="delProjectNow"
              v-if="permissionCheck > 2"
              class="control-btn-new hover-blue-new hint-cont">
        <del-icon></del-icon>
        <p class="btn-hint btn-hint_small btn-hint_bottom">
          {{$t('btns.users.delGroup')}}
        </p>
      </button>
    </footer>
  </aside>
</template>

<script>
  import {mapGetters, mapState, mapMutations, mapActions} from 'vuex'
  import trimItem from '../../trimITem'
  import avatarCont from '../../avatarCont'
  import {filters} from "../../../mixins/filters";
  import starIcon from '../../Svg/projects/starIcon'
  import userIcon from '../../../components/Svg/users/user'
  import dotsIcon from '../../Svg/sidebar/dots'
  import addIcon from '../../Svg/projects/addUser'
  import delIcon from '../../Svg/cart_control/delIcon'
  import {delItem} from "../../../mixins/delItem";
  import {loaderMixin} from "../../../mixins/utils/loaderMixin";
  import {showOverlay} from "../../../mixins/utils/showOverlay";
  import {singleProject} from "../../../mixins/projects/singleProject";
  import {usersInAccount} from "../../../mixins/utils/usersInAccount";

  export default {
    name: 'projectInfo',
    mixins: [filters, delItem, loaderMixin, showOverlay, singleProject, usersInAccount],
    components: {
      trimItem,
      avatarCont,
      starIcon,
      userIcon,
      dotsIcon,
      addIcon,
      delIcon
    },
    data() {
      return {
        avatar: '',
        avatarFile: '',
      }
    },
    computed: {
      ...mapState({
        allRoles: state => state.projects.allRoles,
        isItemProjects: state => state.projects.isItemProjects,
      }),
      ...mapGetters({
        projectOwner: 'projects/projectOwnerRole',
        isAdminRole: 'auth/adminRole',
      }),
      linkToEdit() {
        const route = this.$route;
        if (route.name === 'projectItem') {
          return `/project-edit/${this.singleProject.id}/project-item/${this.project.id}`
        };
        return `/project-edit/${this.singleProject.id}`
      },
      projectId() {
        return this.$route.params.id
      },
      projectRoles() {
        return this.project.permissions.filter(item => {
          return item.value < 4
        })
      },
      projectOwners() {
        if (this.project) {
          let owners = this.project.permissions.filter(item => item.value > 3);
          for (let role of this.allRoles) {
            for (let owner of owners) {
              if (role.id == owner.role_id) {
                owner.user = role.user;
                break;
              }
            }
          }
          return owners
        }
      }
    },
    watch: {
      project(val) {
        if (val) {
          this.avatar = val.image_url
        }
      },
    },
    methods: {
      ...mapMutations({
        showAddPermissionProject: 'projects/SET_SHOW_ADD_PERMISSION',
        showSingleDelModalBlock: 'popups/delSingleProject/SET_SHOW',
        setPermissionType: 'projects/SET_ADD_PERMISSION_TYPE'
      }),
      ...mapActions({
        delProject: 'projects/delProject',
        delProjectItem: 'projects/delProjectItem',
        getProjects: 'projects/getProjects',
      }),
      returnRoleName(id) {
        let item = this.allRoles.filter(item => item.id === id && item.deleted_at === null);
        return item[0]
      },
      ownerRole() {
        return this.projectOwner(this.singleProject.owner_role_id)
      },
      saveAvatar($event) {
        this.avatarFile = $event
      },
      clearAvatar() {
        this.avatar = ''
      },
      delProjectNow() {
        this.showOverlay(true);
        this.setDelItems(this.project.name);
        this.showDelPopup(true);
      },
      async deleteItems() {
        let name;
        let id;
        if (this.$route.name.includes('projectItem')) {
          name = 'delProjectItem';
          id = this.$route.params.item;
        } else {
          name = 'delProject';
          id = this.$route.params.id
        }
        await this[name](id).then(() => {
          this.getProjects();
          this.$router.push({name: 'projects'})
        })
      },
      addPermissionUsers() {
        this.showOverlay(true);
        this.showAddPermissionProject(true);
        this.setPermissionType('user');
      },
      addPermissionRoles() {
        this.showOverlay(true);
        this.showAddPermissionProject(true)
      }
    },
    mounted() {}
  }
</script>

<style lang="scss" scoped>
  .project-info {
    height: calc(100vh - 120px - 30px);
    overflow-y: scroll;
    padding-right: 24px!important;
    padding-bottom: 102px!important;

    @include scrollbal(6px)
  }

  .info-header-left {
    width: calc(100% - 110px);
  }

  .project-info .info-header {
    align-items: flex-start;
  }

  .label {
    margin-bottom: 10px;
  }

  .header-wrap {
    margin-bottom: 20px;
  }

  .desc-wrap {
    min-height: 100/900*100vh;
  }

  .owner-cont {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }

  .icon-small {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
    margin-right: 10px;

    svg {
      max-width: 70%
    }
  }

  .permission-wrap {
    max-height: 55%;
    min-height: 100px;
    overflow-y: scroll;
    @include scrollbal(2px);
    margin-bottom: 0;
  }

  .icon-small_border {
    width: 20px;
  }

  .dots-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    margin-left: auto;
    transition: $anim;
    border-radius: 50%;

    &:hover {
      background: $lightGrey;
    }
  }

  .owner-wrap {
    margin-bottom: 10px;
  }

  .permission-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    margin-bottom: 20px;

    .label {
      margin-bottom: 0;
    }
  }

  .add-permission {
    font-family: $mm;
    font-size: 10px;
    color: $lightBlue;
    display: flex;
    align-items: center;

    svg {
      margin-left: 10px;
    }
  }

  .permission-item {
    margin-bottom: 16px;
  }

  .btn {
    max-height: 40px;
    margin-right: 40px;
  }

  .control-btn {
    min-width: 40px;
    height: 40px;
  }

  .project-desc {
    background: none;
    border: none;
    cursor: text!important;
    outline: none;
    resize: none;
    width: 100%;
    height: 100px;
    font-family: MR, Arial, sans-serif;
    font-size: 14px;
    letter-spacing: 0.25px;
    font-weight: normal;
    color: $darkBlue;

    @include scrollbal(2px)
  }

  .owner-name-cont {
    position: relative;

    svg {
      position: absolute;
      right: -12px;
      top: -2px;
    }
  }

  .bit-title .hint-cont {
    //ненужный отступ названия проекта
    margin-left: 0;
    font-size: 18px;
  }

  .info-body {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: normal;
  }

  .info-footer {
    margin-bottom: auto;
    margin-top: 0!important;
    position: fixed;
    max-width: 360px;

    background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.8) 24.71%, #FFFFFF 46.93%);
    padding: 30px;
    left: auto;
    right: 30px;
    bottom: 30px;
  }
</style>
<style lang="scss">
.bit-title .trim-text {
  min-height: 24px;
}
</style>
